import moment from "moment";


export function splitFileName(fileName) {
    const parts = fileName.split('.')
    if (parts.length > 1) {
        const extra = parts.pop()
        return [parts.join('.'), extra]
    } else {
        return parts
    }
}

export function extendFileName(file) {
    const [fileName, extraName] = splitFileName(file)
    const str = generateRandomString()
    const time = generateTimeString()
    return `${fileName}_${time}_${str}.${extraName}`
}


export function generateRandomString() {
    return Math.random().toString(36).substr(5);
}


export function generateTimeString(time = new Date()) {
    return moment(time).format('YYYYMMDDHHmmss')
}
